import React from "react";
//import moment from "moment";
// import Search from "../../../../components/search";
import { useSelector } from "react-redux";
import { session_id_beg,session_id_end } from "../../../../../utils/helpers";
import Pagination from "../../../../../components/tablePagination";
import { useTranslation } from "react-i18next";
import { useDynamicTranslation } from "../../../../../i18n/dynamicContent";
export default function NoShows(props) {
  const { t } = useTranslation("clientSessions");
  const { tc } = useDynamicTranslation(); // session type names from the API
  const {
    tableData=[],
    changeHandler,
    onClickHandler,
    tableHeaders=[],
    // filterListAppointments,
    openSurveyLink,
    getPaginationData,
    setFilterValues,
    setSearchValues
  } = props;
  const {
    allNoShowCount
  } =  useSelector((state) => state.client);
  return (
    <>
      <div className="d-flex justify-content-end gap-10 flex-wrap">
        {/* <Search callApi={filterListAppointments} list={filterList} /> */}
      </div>
      <div className="table-box-medium admin-appoi" style={{ overflow: "visible" }}>
        <div className="appt-table-scroll" style={{ overflowX: "scroll", width: "100%" }}>
        <table className="caseTable">
          <tbody>
            <tr className="dark">
              {React.Children.toArray(
                tableHeaders.map((item) => <th>{item.labelKey ? t("appointments.table." + item.labelKey, { defaultValue: item.title }) : item.title}</th>)
              )}
            </tr>
            {tableData.length > 0 ? (
              tableData.map((appoinment) => (
                <tr className="innr">
                   <td>{session_id_beg+appoinment.id+session_id_end}</td>
                  <td>
                    <span className="capitalize">
                      {" "}
                      {appoinment.medium_name}
                    </span>
                  </td>
                  <td style={{ whiteSpace: "normal", wordBreak: "break-word", minWidth: 160, maxWidth: 220 }}>{tc(appoinment.session_name)}</td>
                  <td>
                    <div style={{ fontWeight: '500' }}>{appoinment.date}</div>
                    <div style={{ color: '#666', fontSize: '13px', marginTop: '2px' }}>{appoinment.time}</div>
                  </td>
  

                  <td>
                  {appoinment.userby}
           
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={20} style={{ padding: '48px 0', textAlign: 'center' }}>
                  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '12px' }}>
                    <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <circle cx="12" cy="8" r="4" stroke="#d5a67b" strokeWidth="1.5"/>
                      <path d="M4 20c0-4 3.582-7 8-7s8 3 8 7" stroke="#d5a67b" strokeWidth="1.5" strokeLinecap="round"/>
                    </svg>
                    <p style={{ margin: 0, fontSize: '15px', fontWeight: '600', color: '#485257' }}>{t("appointments.noAppointments")}</p>
                  </div>
                </td>
              </tr>
            )}
          </tbody>
        </table>
                </div>
        <Pagination  rowsPerPageOptions={[5, 10, 25]}  count={allNoShowCount} activeTab={"noshows"} getPaginationData={getPaginationData} />
      </div>
    </>
  );
}
